import useReveal from './useReveal';

const stats = [
  { num: '2',    label: 'Stages professionnels' },
  { num: '5+',   label: 'Stack technologies ML' },
  { num: '2026', label: 'Oracle Java SE 17 Certifiée' },
];

export default function About() {
  const [ref, visible] = useReveal();
  return (
    <section id="about" style={{ position: 'relative', zIndex: 1 }}>
      <div style={{ maxWidth: 1100, margin: '0 auto', padding: '6rem 3rem' }}>
        <div style={{ fontFamily: "'Space Mono', monospace", fontSize: '0.7rem', color: '#00e5ff', letterSpacing: '0.25em', textTransform: 'uppercase', marginBottom: '0.75rem', display: 'flex', alignItems: 'center', gap: '0.8rem' }}>
          01 // À propos
          <span style={{ flex: 1, maxWidth: 80, height: 1, background: '#00e5ff', opacity: 0.4 }} />
        </div>
        <h2 style={{ fontSize: 'clamp(2rem, 4vw, 3.2rem)', fontWeight: 800, lineHeight: 1.1, letterSpacing: '-0.02em', marginBottom: '3rem' }}>
          Construire l'IA qui<br /><span style={{ color: '#00e5ff' }}>surveille, détecte, alerte.</span>
        </h2>

        <div ref={ref} style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '4rem', alignItems: 'start', opacity: visible ? 1 : 0, transform: visible ? 'none' : 'translateY(30px)', transition: 'opacity 0.7s ease, transform 0.7s ease' }}>
          <div>
            {[
              <><strong style={{ color: '#e2f0f5' }}>Chaimae Kazoury</strong>, étudiante en 3ème année d'ingénierie en Informatique et Intelligence Artificielle à <strong style={{ color: '#e2f0f5' }}>ENSAM Casablanca</strong>. Passionnée par le domaine du système de monitoring intelligents et la détection d'anomalies sur données de capteurs industriels.</>,
              <>Mon projet <strong style={{ color: '#e2f0f5' }}>Machine Failure Detection</strong> illustre directement cette vision : pipeline de prétraitement, modèle supervisé de classification d'état machine, backend Django et dashboard React — exactement le spectre du Sujet 1 de YaneCode Digital.</>,
            ].map((p, i) => <p key={i} style={{ color: '#5a8a9f', lineHeight: 1.9, fontSize: '0.95rem', marginBottom: '1.2rem' }}>{p}</p>)}
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1, background: '#1a3040' }}>
            {stats.map(s => (
              <div key={s.label} style={{ background: '#0f1c24', padding: '1.8rem', display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
                <div style={{ fontFamily: "'Space Mono', monospace", fontSize: '2.4rem', fontWeight: 700, color: '#00e5ff', lineHeight: 1 }}>{s.num}</div>
                <div style={{ fontSize: '0.8rem', color: '#5a8a9f' }}>{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
